import type { FirebaseOptions } from 'firebase/app';

export const firebaseConfig: FirebaseOptions = {
  apiKey: 'AIzaSyCQj639XYcGKtgAHTeBhIqXvjYpcV83I6k',
  authDomain: 'auth.superfunnel.ai',
  databaseURL:
    'https://ai-marketing-agents-406e0-presence.europe-west1.firebasedatabase.app',
  projectId: 'ai-marketing-agents-406e0',
  storageBucket: 'ai-marketing-agents-406e0.firebasestorage.app',
  messagingSenderId: '610135364519',
  appId: '1:610135364519:web:743f2d20c53e451f919c82',
  measurementId: 'G-E8HPSD4X06',
};

export const firebaseMessagingVapidKey =
  import.meta.env.VITE_FIREBASE_MESSAGING_VAPID_KEY ?? '';
